exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-data-available {\r\n    text-align: center;\r\n}\r\n\r\n.dataTables_empty {\r\n    display: none;\r\n}\r\n\r\n.input-error {\r\n    border-right: solid 5px red !important;\r\n}\r\n\r\n.input-success {\r\n}\r\n\r\n.cus-modal-dialog {\r\n    width: 600px;\r\n}\r\n\r\n.color-red {\r\n    color: red;\r\n}\r\n\r\n.color-green {\r\n    color: green;\r\n }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/coin-candlestick-condition/coin-candlestick-condition/coin-candlestick-condition.component.css
// module id = ../../../../../src/app/_components/coin-candlestick-condition/coin-candlestick-condition/coin-candlestick-condition.component.css
// module chunks = main